export default "/_next/static/fonts/b0f63bb4364081d0ab74023380b09d48.eot";